import React, { useState } from "react"
import { TextTag, Button, PhoneInput } from "../../atoms"
import "./MobileSignIn.scss"
import { connect } from "react-redux"
import { loginByMobile } from "../../redux/actionCreators/auth"
import { withRouter, Link } from "react-router-dom"
import {
  LOGIN_BUTTON,
  INVALID_MOBILE,
  SIGN_UP_BUTTON,
  SIGN_IN_TO,
  OR,
  NO_ACCOUNT_LABEL,
  CONTINUE_EMAIL,
  INVALID_FLAG_SELECTED,
  CONTACT_YOU_PHONE_LABEL,
  PHONE_NUMBER_REQUIRED,
} from "../../constants/messages"
import _ from "../../utils/lodashUtils"
import SignUpSignInFooter from "../SignUpSignInFooter/SignUpSignInFooter"
import { formatPhoneNumber, osType } from "../../utils/helpers"
import { useChange } from "common-custom-hooks"

const MobileSignIn = (props) => {
  const { loginByMobile } = props
  const [mobile, setMobile] = useState("")
  const [error, setError] = useState(true)
  const [errorMsg, setErrorMsg] = useState("")
  const [formattedValue, setMobileWithformat] = useState("")
  const [country, setCountryName] = useState("")
  const [defaultPhoneNumber, setDefaultPhoneNumber] = useState()
  const reg = new RegExp("[-() ]", "g")
  const typeOfOs = osType()

  const submitData = () => {
    loginByMobile({ mobile }, props.isPartnerSignup).then((response) => {
      if (_.get(response, "status") === 400) {
        setError(true)
        setErrorMsg(_.get(response.data, "error"))
      }
    })
  }

  useChange(
    props.phoneNumber,
    () => {
      const { phoneNumber } = props
      if (phoneNumber) {
        const formattedPhoneNumber = formatPhoneNumber(phoneNumber)

        let defaultPhoneNumber =
          formattedPhoneNumber && formattedPhoneNumber.intlCode
            ? `${formattedPhoneNumber.intlCode} ${formattedPhoneNumber.telephoneNumber}`
            : phoneNumber
        setDefaultPhoneNumber(defaultPhoneNumber)
      }
    },
    _.isEqual
  )

  const renderPhoneInput = () => {
    const phoneInputProps = {
      format: "true",
      formatOnInit: true,
      separateDialCode: "true",
      numberType: "MOBILE",
      placeholder: CONTACT_YOU_PHONE_LABEL,
      onPhoneNumberBlur: (isPhoneValid, number) => {
        if (!isPhoneValid && !number) {
          setError(true)
          setErrorMsg(PHONE_NUMBER_REQUIRED)
        }
      },
      onPhoneNumberChange: (isValid, number, data, formattedValue) => {
        if (isValid) {
          setCountryName(data.name)
          let phoneNumber = formattedValue.replace(reg, "")
          setMobile(phoneNumber)
          setMobileWithformat(formattedValue)
          setError(!isValid)
        } else {
          setError(!isValid)
          setErrorMsg(INVALID_MOBILE)
        }
      },
      onSelectFlag: (number, obj, formattedValue, isWrong) => {
        if (number !== "" && !isWrong) {
          setError(!isWrong)
          setErrorMsg(INVALID_FLAG_SELECTED)
        } else {
          setErrorMsg("")
        }
      },
    }
    if (defaultPhoneNumber) {
      // different keys here to trick React into rendering two different components for phoneInput
      // why? because react-intl-tel-input package used underneath this phoneInput component has a bug
      // or you might call it a deficiency which doesn't take changes to default values into account.
      // but our default value fetched from API will change, hence once it is present,
      // we render a new component with the default value. Sad but okay. 🤷🏻‍♂️
      return (
        <PhoneInput
          {...phoneInputProps}
          key={"default"}
          defaultValue={defaultPhoneNumber}
          error={error ? errorMsg : ""}
        />
      )
    } else
      return (
        <PhoneInput
          key={"new"}
          {...phoneInputProps}
          error={error ? errorMsg : ""}
        />
      )
  }

  return (
    <div className="mobile-sign-container">
      <div className="signin-text">
        <TextTag textType="spaceName">{SIGN_IN_TO}</TextTag>
        <div className="noacc-text">
          <TextTag textType="sectionTextPrimary">{NO_ACCOUNT_LABEL}</TextTag>
          <Link to="/">
            <TextTag textType="linkText"> {SIGN_UP_BUTTON}</TextTag>
          </Link>
        </div>
      </div>
      <div className="separator"></div>
      <div
        className={`telephone ${typeOfOs === "Linux" ? "" : "condition-width"}`}
      >
        {renderPhoneInput()}
      </div>
      <Button
        btnSize="large"
        btnType="primary"
        className="login-form-button"
        onClick={submitData}
        disabled={error}
      >
        {" "}
        {LOGIN_BUTTON}
      </Button>
      <h2>
        <span>{OR}</span>
      </h2>
      <Button
        btnSize="large"
        btnType="primary"
        className="login-form-button email-link"
      >
        <Link to="/login-email">{CONTINUE_EMAIL}</Link>
      </Button>
      <div className="email-link-msg">
        <SignUpSignInFooter />
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
})

export default connect(mapStateToProps, { loginByMobile })(
  withRouter(MobileSignIn)
)
